import { Playground, Props } from 'docz';
import { Colors } from "../../../../../documentation/styling/helpers";
import * as React from 'react';
export default {
  Playground,
  Props,
  Colors,
  React
};